import apiHandler from "../core/apiHandler";

const debitNotePurchaseApi = apiHandler('debit-note-purchases');
export default debitNotePurchaseApi;
